import { QuestionRoomI18nAddressRoot } from "./address/root";
import { QuestionRoomBase } from "./base/root";

import type { StandardRoomI18nCategoriesAndManagerStore } from "../_store/categories";

type Props = {
	roomCategoriesAndManagerStore: Omit<
		StandardRoomI18nCategoriesAndManagerStore,
		"categoryManagerStore" | "categoryStoreArray"
	>;
};

export const RoomFormMain = ({ roomCategoriesAndManagerStore }: Props) => {
	const {
		base, //
		address,
	} = roomCategoriesAndManagerStore;

	return (
		<>
			<QuestionRoomBase base={base} />
			<QuestionRoomI18nAddressRoot address={address} />
		</>
	);
};

RoomFormMain.displayName = "RoomFormMain";
